// import React, { useEffect, useRef, useState } from "react";
// import { Box, Typography } from "@mui/material";
// import mermaid from "mermaid";

// mermaid.initialize({
//   startOnLoad: false,
//   theme: "dark",
// });

// export default function CodeUI({ explanation, code }) {
//   const [flow, setFlow] = useState(null);
//   const [loadingFlow, setLoadingFlow] = useState(false);
//   const flowRef = useRef(null);

//   const handleCopy = async () => {
//     try {
//       await navigator.clipboard.writeText(code);
//     } catch (err) {
//       console.error("Failed to copy code:", err);
//     }
//   };

//   const handleGenerateFlow = async () => {
//     if (flow) return; // prevent refetch
//     const id_token = sessionStorage.getItem('id_token')
//     setLoadingFlow(true);
//     try {
//         let body =JSON.stringify({ "query":code })
//       const response = await fetch("https://flow-generator-188976723880.europe-west1.run.app", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${id_token}`, // Google ID token or your JWT
//         },
//         body: body,
//       });

//       const data = await response.json();
//       setFlow(data.text);
//     } catch (err) {
//       console.error("Flow generation failed", err);
//     } finally {
//       setLoadingFlow(false);
//     }
//   };

//   useEffect(() => {
//     if (flow && flowRef.current) {
//       mermaid.run({
//         nodes: [flowRef.current],
//       });
//     }
//   }, [flow]);

//   return (
//     <Box sx={{ maxWidth: "900px", margin: "24px 0" }}>
//       {/* Explanation */}
//       <Box sx={{ mb: 1.5 }}>
//         <Typography
//           variant="subtitle1"
//           sx={{ fontWeight: 600, color: "#065f46", mb: 0.5 }}
//         >
//           Explanation
//         </Typography>

//         <Box
//           sx={{ fontSize: "14px", lineHeight: 1.7, color: "#111827" }}
//           dangerouslySetInnerHTML={{ __html: explanation }}
//         />
//       </Box>

//       {/* Code Section */}
//       <Box
//         sx={{
//           backgroundColor: "#020617",
//           borderRadius: "10px",
//           boxShadow: "0 0 0 1px #1e293b",
//           overflow: "hidden",
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             px: 2,
//             py: 1,
//             borderBottom: "1px solid #1e293b",
//             fontSize: "13px",
//             color: "#94a3b8",
//           }}
//         >
//           <Typography variant="caption">Python</Typography>

//           <Box>
//             <Box
//               component="span"
//               onClick={handleCopy}
//               sx={{
//                 border: "1px solid #334155",
//                 px: 1.2,
//                 py: 0.4,
//                 borderRadius: "6px",
//                 mr: 1,
//                 color: "#e5e7eb",
//                 fontSize: "12px",
//                 cursor: "pointer",
//                 "&:hover": { backgroundColor: "#1e293b" },
//               }}
//             >
//               📋 Copy Code
//             </Box>

//             <Box
//               component="span"
//               onClick={handleGenerateFlow}
//               sx={{
//                 border: "1px solid #334155",
//                 px: 1.2,
//                 py: 0.4,
//                 borderRadius: "6px",
//                 color: "#e5e7eb",
//                 fontSize: "12px",
//                 cursor: "pointer",
//                 "&:hover": { backgroundColor: "#1e293b" },
//               }}
//             >
//               {loadingFlow ? "⏳ Generating..." : "🔄 Generate Flow"}
//             </Box>
//           </Box>
//         </Box>

//         {/* Code Block */}
//         <Box
//           component="pre"
//           sx={{
//             m: 0,
//             p: 2,
//             overflowX: "auto",
//             fontSize: "14px",
//             lineHeight: 1.6,
//             color: "#e5e7eb",
//             fontFamily: "Consolas, Monaco, monospace",
//           }}
//         >
//           <code>{code}</code>
//         </Box>
//       </Box>

//       {/* Mermaid Flow */}
//       {flow && (
//         <Box
//           sx={{
//             mt: 2,
//             background: "#020617",
//             borderRadius: "10px",
//             p: 2,
//             border: "1px solid #1e293b",
//           }}
//         >
//           <Box ref={flowRef} className="mermaid">
//             {flow}
//           </Box>
//         </Box>
//       )}
//     </Box>
//   );
// }
import React, {useState } from "react";
import { Box, Typography } from "@mui/material";
import mermaid from "mermaid";

/* 🔒 Initialize Mermaid ONCE */
mermaid.initialize({
  startOnLoad: false,
  theme: "dark",
  securityLevel: "loose", // REQUIRED for React
});

export default function CodeUI({ explanation, code }) {
  const [flowSvg, setFlowSvg] = useState(null);
  const [loadingFlow, setLoadingFlow] = useState(false);
  const [flowError, setFlowError] = useState(null);

  /* 📋 Copy Code */
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  /* 🔄 Generate Flow */
  const handleGenerateFlow = async () => {
    if (loadingFlow || flowSvg) return;

    const id_token = sessionStorage.getItem("id_token");
    setLoadingFlow(true);
    setFlowError(null);

    try {
      const response = await fetch(
        "https://flow-generator-188976723880.europe-west1.run.app",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${id_token}`,
          },
          body: JSON.stringify({ query: code }),
        }
      );

      const contentType = response.headers.get("content-type");
      const data =
        contentType && contentType.includes("application/json")
          ? await response.json()
          : { text: await response.text() };

      const mermaidText = data.text?.trim();
      if (!mermaidText) throw new Error("Empty Mermaid response");

      /* 🧪 Basic hard validation */
      if (!mermaidText.startsWith("flowchart")) {
        throw new Error("Invalid Mermaid root node");
      }

      /* ✅ Syntax validation */
      await mermaid.parse(mermaidText);

      /* 🎨 Render to SVG (React-safe) */
      const { svg } = await mermaid.render(
        `flow-${crypto.randomUUID()}`,
        mermaidText
      );

      setFlowSvg(svg);
    } catch (err) {
      console.error("Mermaid render failed:", err);
      setFlowError("Failed to generate flow diagram.");
      setFlowSvg(null);
    } finally {
      setLoadingFlow(false);
    }
  };

  return (
    <Box sx={{ maxWidth: "900px", margin: "24px 0" }}>
      {/* Explanation */}
      <Box sx={{ mb: 1.5 }}>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, color: "#065f46", mb: 0.5 }}
        >
          Explanation
        </Typography>

        <Box
          sx={{ fontSize: "14px", lineHeight: 1.7, color: "#111827" }}
          dangerouslySetInnerHTML={{ __html: explanation }}
        />
      </Box>

      {/* Code Section */}
      <Box
        sx={{
          backgroundColor: "#020617",
          borderRadius: "10px",
          boxShadow: "0 0 0 1px #1e293b",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            py: 1,
            borderBottom: "1px solid #1e293b",
            fontSize: "13px",
            color: "#94a3b8",
          }}
        >
          <Typography variant="caption">Python</Typography>

          <Box>
            <Box
              component="span"
              onClick={handleCopy}
              sx={{
                border: "1px solid #334155",
                px: 1.2,
                py: 0.4,
                borderRadius: "6px",
                mr: 1,
                color: "#e5e7eb",
                fontSize: "12px",
                cursor: "pointer",
                "&:hover": { backgroundColor: "#1e293b" },
              }}
            >
              📋 Copy Code
            </Box>

            <Box
              component="span"
              onClick={handleGenerateFlow}
              sx={{
                border: "1px solid #334155",
                px: 1.2,
                py: 0.4,
                borderRadius: "6px",
                color: "#e5e7eb",
                fontSize: "12px",
                cursor: "pointer",
                "&:hover": { backgroundColor: "#1e293b" },
              }}
            >
              {loadingFlow ? "⏳ Generating..." : "🔄 Generate Flow"}
            </Box>
          </Box>
        </Box>

        {/* Code Block */}
        <Box
          component="pre"
          sx={{
            m: 0,
            p: 2,
            overflowX: "auto",
            fontSize: "14px",
            lineHeight: 1.6,
            color: "#e5e7eb",
            fontFamily: "Consolas, Monaco, monospace",
          }}
        >
          <code>{code}</code>
        </Box>
      </Box>

      {/* Error */}
      {flowError && (
        <Box sx={{ mt: 2, color: "#dc2626", fontSize: "13px" }}>
          {flowError}
        </Box>
      )}

      {/* Mermaid SVG */}
      {flowSvg && (
        <Box
          sx={{
            mt: 2,
            background: "#020617",
            borderRadius: "10px",
            p: 2,
            border: "1px solid #1e293b",
            overflowX: "auto",
          }}
          dangerouslySetInnerHTML={{ __html: flowSvg }}
        />
      )}
    </Box>
  );
}
